import React, { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { Modal, Form, Button, Icon, Input, Grid, Table, Pagination, Popup, Select } from 'semantic-ui-react';
import { setActivePage, setOrderFilter, getOrders, showLoading, hideLoading, exportOrders, getOrdersReport, openCustomModal,getHolidays } from '../actions';
import { OrderFilter } from '../config';
import OrderMenu from '../components/OrderMenu';
import OrderDetails from './OrderDetails';
import GetProduct from './GetProduct';

const periodOptions = [
    { key: 'Monthly', text: 'Month', value: 'Monthly' },
    { key: 'Yearly', text: 'Year', value: 'Yearly' }
]

const monthOptions = [
    { key: '0', text: 'Jan', value: 0 },
    { key: '1', text: 'Feb', value: 1 },
    { key: '2', text: 'Mar', value: 2 },
    { key: '3', text: 'Apr', value: 3 },
    { key: '4', text: 'May', value: 4 },
    { key: '5', text: 'Jun', value: 5 },
    { key: '6', text: 'Jul', value: 6 },
    { key: '7', text: 'Aug', value: 7 },
    { key: '8', text: 'Sep', value: 8 },
    { key: '9', text: 'Oct', value: 9 },
    { key: '10', text: 'Nov', value: 10 },
    { key: '11', text: 'Dec', value: 11 }
]

class Orders extends Component {
    constructor(props) {
        super(props);
        let now = new Date();
        this.year = now.getFullYear();
        this.month = now.getMonth();
        this.yearOptions = _.range(this.year, this.year - 10, -1).map(year => { return { key: year, text: year, value: year } });
        this.state = {
            column: null,
            data: [],
            length: 0,
            page: 0,
            rowsPerPage: 15,
            direction: 'descending',
            order: 'order_date',
            selectedPeriod: 'Monthly',
            selectedYear: this.year,
            selectedMonth: this.month,
            formType: null,
            showError: false
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    componentWillMount() {
        this.props.showLoading('Retrieving orders . . .');
        let cat = (this.props.match.params.cat) ? this.props.match.params.cat : 'All';
        console.log(cat);
        this.props.setOrderFilter(cat);
        if (cat === 'All') {
            this.props.getOrders({});
        } else {
            this.props.getOrders({ status: cat });
        }
        this.props.getHolidays({});
    }

    componentDidMount() {
        this.props.setActivePage('orders');
    }

    componentWillReceiveProps(nextProps) {
        console.log('Order componentWillReceiveProps');
        if (this.props.order.order_list !== nextProps.order.order_list) {
            this.setState({ data: _.chunk(nextProps.order.order_list, this.state.rowsPerPage), length: nextProps.order.order_list.length, page: 0 });
            this.props.hideLoading();
        }

        if (this.props.match.params.cat !== nextProps.match.params.cat) {
            console.log(this.props.location.search);
            this.props.showLoading('Retrieving orders . . .');
            let cat = (nextProps.match.params.cat) ? nextProps.match.params.cat : 'All';

            this.props.setOrderFilter(cat);
            if (cat === 'All') {
                this.props.getOrders({});
            } else {
                this.props.getOrders({ status: cat });
            }
        }
    }

    handleSort = clickedColumn => () => {
        const { column, data, direction } = this.state

        if (column !== clickedColumn) {
            this.setState({
                column: clickedColumn,
                data: _.sortBy(data, [clickedColumn]),
                direction: 'ascending',
            })

            return
        }

        this.setState({
            data: data.reverse(),
            direction: direction === 'ascending' ? 'descending' : 'ascending',
        })
    }

    handleOrderClick(order, e) {
        // e.preventDefault();
        this.props.history.push('/order_details/' + order);
    }

    handleInputChange(e, data) {
        console.log(e);
        console.log(data);
        this.setState({
            [data.id]: data.value
        });
    }

    handleGenerateReport() {
        this.props.exportOrders(false);
        this.props.showLoading('Generating orders report . . .');
        this.props.getOrdersReport({ period: this.state.selectedPeriod, month: this.state.selectedMonth, year: this.state.selectedYear });
    }

    closeModal() {
        this.props.exportOrders(false);
    }

    handleSearchChange = (e) => {
        var sValue = e.target.value;
        this.setState({ searchValue: sValue });
    }

    handleSearchSubmit = (e) => {
        const re = new RegExp(_.escapeRegExp(e.target.value), 'i')
        const isMatch = result => (re.test(result.order_details.customer.name) || re.test(result._id));

        let list = _.filter(this.props.order.order_list, isMatch);
        this.setState({ data: _.chunk(list, this.state.rowsPerPage), length: list.length });
    }

    handleButton(page) {
        this.setState({
            orderingPage: page
        });
    }

    handleRefresh = () => {
        this.props.showLoading('Retrieving orders . . .');
        this.props.getOrders({});
        console.log("Refresh List");
    }

    handleOpen = () => {
        if (this.state.formType) {
            this.props.openCustomModal(true);
        } else {
            this.setState({ showError: true });
        }
    }

    handleDrop = (e, { value }) => {
        this.setState({ formType: value, showError: false });
    }

    render() {
        const { column, data, direction, selectedPeriod, selectedYear, selectedMonth, page, rowsPerPage, length, searchValue, formType } = this.state;
        const { exportModal, customModal } = this.props.order;

        return (
            <Fragment>
                <Modal open={exportModal}  onClose={this.closeModal.bind(this)}>
                    <Modal.Header>
                        Export Orders Report
                    </Modal.Header>
                    <Modal.Content>
                        <Form>
                            <Form.Group widths='equal'>
                                <Form.Select fluid options={periodOptions} id='selectedPeriod' value={selectedPeriod} onChange={this.handleInputChange} />
                                <Form.Select fluid options={this.yearOptions} id='selectedYear' value={selectedYear} onChange={this.handleInputChange} />
                                <Form.Select fluid options={monthOptions} id='selectedMonth' value={selectedMonth} onChange={this.handleInputChange} disabled={selectedPeriod !== 'Monthly'} />
                            </Form.Group>
                        </Form>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={this.closeModal.bind(this)}>Close</Button>
                        <Button color='primary' onClick={this.handleGenerateReport.bind(this)}>Export</Button>
                    </Modal.Actions>
                </Modal>
                { customModal &&
                    <GetProduct formType={formType} />
                }
                <Grid>
                    <Grid.Column floated='left' width={4}>
                        <Input icon='search' fluid  placeholder='Search...' value={searchValue} onKeyUp={this.handleSearchSubmit} onChange={this.handleSearchChange} />
                    </Grid.Column>
                    <Grid.Column width={5}>
                    <Input type='text' placeholder='Search...' action>
                        <Popup
                            trigger={<Select placeholder='Product' selection options={getopt} onChange={this.handleDrop} value={formType} />}
                            content='Please choose a product type'
                            open={this.state.showError}
                            style={{opacity: 0.8}}
                            inverted
                        />
                        <Button content='Generate' primary onClick={this.handleOpen.bind(this)} />
                    </Input>
                    </Grid.Column>
                    <Grid.Column floated='right' width={1}>
                        <Button icon onClick={this.handleRefresh}><Icon name='refresh'/></Button>
                    </Grid.Column>
                </Grid>
                <Table sortable striped selectable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell style={{ textAlign: 'center' }}>
                                <Icon name='info circle' size='large' />
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === '_id' ? direction : null} onClick={this.handleSort('_id')}>
                                Order #
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === 'name' ? direction : null} onClick={this.handleSort('name')}>
                                Customer
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Ship To
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Total
                            </Table.HeaderCell>
                            <Table.HeaderCell sorted={column === 'order_date' ? direction : null} onClick={this.handleSort('order_date')}>
                                Order Date
                            </Table.HeaderCell>
                            <Table.HeaderCell>
                                Expected Completion
                            </Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {data[page] &&
                            (data.length > 0) ?
                            data[page].map((orderBundle) => {
                                let order = orderBundle.order_details;
                                let status_icon = '';
                                let status_color = '';

                                if (orderBundle.status === 'Ordered') {
                                    status_icon = 'warning circle';
                                    status_color = 'orange';
                                } else if (orderBundle.status === 'Paid') {
                                    status_icon = 'add circle';
                                    status_color = 'olive';
                                } else if (orderBundle.status === 'Processed') {
                                    status_icon = 'minus circle';
                                    status_color = 'teal';
                                } else if (orderBundle.status === 'Shipped') {
                                    status_icon = 'check circle';
                                    status_color = 'green';
                                } else {
                                    status_icon = 'remove circle';
                                    status_color = 'red';
                                }

                                return (
                                    <Table.Row key={orderBundle._id} onClick={this.handleOrderClick.bind(this, orderBundle._id)}>
                                        <Table.Cell style={{ textAlign: 'center' }}>
                                            <Icon name={status_icon} color={status_color} size='large' />
                                        </Table.Cell>
                                        <Table.Cell>{orderBundle._id}</Table.Cell>
                                        <Table.Cell>{order.customer.name}</Table.Cell>
                                        {(order.recipient)
                                            ? (
                                                <Table.Cell>
                                                    <span>{order.recipient.name}</span><br />
                                                    <span>{order.recipient.address.address_1},</span>
                                                    {(order.recipient.address.address_2.length > 0) && <span>{order.recipient.address.address_2},</span>}
                                                    <span>{order.recipient.address.town_city},</span>
                                                    <span>{order.recipient.address.postcode} {order.recipient.address.state},</span>
                                                    <span>{order.recipient.address.country}</span>
                                                </Table.Cell>)
                                            : (
                                                <Table.Cell>
                                                    <span>{order.customer.name}</span><br />
                                                    <span>{order.customer.address.address_1},</span>
                                                    {(order.customer.address.address_2.length > 0) && <span>{order.customer.address.address_2},</span>}
                                                    <span>{order.customer.address.town_city},</span>
                                                    <span>{order.customer.address.postcode} {order.customer.address.state},</span>
                                                    <span>{order.customer.address.country}</span>
                                                </Table.Cell>)
                                        }
                                        <Table.Cell>
                                            RM {order.total_amount.toFixed(2)}
                                        </Table.Cell>
                                        <Table.Cell>
                                            {moment(orderBundle.order_date).format('DD/MM/YYYY HH:mm')}
                                        </Table.Cell>
                                        <Table.Cell className={((orderBundle.status !== 'Shipped') && (orderBundle.status !== 'Canceled') && moment().isAfter(moment(orderBundle.order_date).add(orderBundle.order_details.process_days, 'days'))) ? 'warning-text' : ''}>
                                            {moment(orderBundle.order_date).add(orderBundle.order_details.process_days, 'days').format('DD/MM/YYYY')}
                                        </Table.Cell>
                                    </Table.Row>
                                )
                            }) :
                            <Table.Row>
                                <Table.Cell colSpan="7" textAlign="center">
                                    No Record Found
                             </Table.Cell>
                            </Table.Row>
                        }
                    </Table.Body>
                </Table>
                <Pagination style={{ float: 'right' }} activePage={page + 1} totalPages={Math.ceil(length / rowsPerPage)} onPageChange={(e, data) => this.setState({ page: data.activePage - 1 })} />
            </Fragment>
        )
    }
}

const getopt = [
    { key: 'General', value: 'generalForm', text: 'General' },
    { key: 'Booklet', value: 'bookletForm', text: 'Booklet' }
]

const mapStateToProps = ({ order, sales, holiday }) => {
    return { order, sales, holiday}
}

const matchDispatchToProps = (dispatch) => {
    return bindActionCreators({
        setActivePage: setActivePage,
        setOrderFilter: setOrderFilter,
        getOrders: getOrders,
        showLoading: showLoading,
        hideLoading: hideLoading,
        exportOrders: exportOrders,
        getOrdersReport: getOrdersReport,
        openCustomModal: openCustomModal,
        getHolidays:getHolidays
    }, dispatch);
}

export default connect(mapStateToProps, matchDispatchToProps)(Orders);
